import { moduleNames } from "data/enums/modules";
import { enumPermissionModules as EPM, enumPermissions as EP } from "../enums/authorization";

const enumTranslations = {
  spreadsheetsType: {
    "employee-payment-trimester": "Employee payment trimester",
    "employee-tax-deduction": "Employee tax deduction",
    "planner": "Planner",
    "employee-annual-sheet": "Employee annual sheet",
  },
  spreadsheetsStatus: {
    1: "Pending",
    2: "Created",
    9: "Deleted"
  },
  workingSiteStatus: {
    1: "Active",
    2: "Inactive"
  },
  reccurenceType: {
    daily: "Daily",
    weekly: "Weekly",
    every_2_weeks: "Every 2 weeks",
    every_3_weeks: "Every 3 weeks",
    monthly: "Monthly",
    annually: "Annually"
  },
  dayOfWeek: {
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    sunday: "Sunday"
  },
  weekOfMonth: {
    first: "First",
    second: "Second",
    third: "Third",
    fourth: "Fourth",
    last: "Last"
  },
  interval: {
    1: '1',
    2: '2',
    3: '3'
  },
  duration: {
    "this-week": "This week",
    "this-month": "This month",
    "this-year": "This year",
    "unlimited": "Unlimited"
  },
  taxEmployeesStatus: {
    1: "Pending",
    2: "Created",
    9: "Deleted"
  },
  taxEmployeesTrimester: {
    1: 'January-February-March',
    2: 'April-May-June',
    3: 'July-August-September',
    4: 'October-November-December'
  },
  workingHoursSubmissionsStatus: {
    2: 'Approved',
    3: 'Rejected',
    1: 'Pending',
    default: 'Unknown'
  },
  employeesNumberOfchildren: {
    1: '1',
    2: '2',
    3: '3',
    4: '4',
    5: '5',
    6: '6',
    7: '7',
    8: '8',
    default: "Unknown",
  },
  employeeJobType: {
    "flex-site": 'Flexible site',
    "fixed-site": 'Fixed site',
    default: "Unknown",
  },
  employeesSex: {
    male: 'Male',
    female: 'Female',
    default: "Unknown",
  },
  employeesHasChildren: {
    yes: 'Yes',
    no: 'No',
    default: "Unknown",
  },
  taxScalesGroups: {
    A: 'A',
    B: 'B',
    C: 'C',
    H: 'H',
    default: "Unknown",
  },
  formsTemplatesStatus: {
    default: "Unknown",
    active: "Active",
    deleted: "Deleted",
  },
  formsTemplatesExpires: {
    default: "Unknown",
    daily: "Daily",
    weekly: "Weekly",
    annually: "Annually",
    'no-limit': 'No limit'
  },
  formsTemplatesTarget: {
    employees: "Employees",
    partners: "Partners",
    public: "Public",
    default: "Unknown",
  },
  usersStatus: {
    1: 'Admin',
    99: 'Banovan'
  },
  employeesStatus: {
    default: "Unknown",
    1: "Active",
    2: "Inactive",
    3: "Pending signup",
    4: "Pending approval",
    9: 'Deleted'
  },
  employeesReligion: {
    default: "Unknown",
    agnostic: "Agnostic",
    muslim: "Muslim",
    christian: 'Christian',
    jewish: 'Jewish',
    atheist: 'Atheist',
  },
  salaryinfo: {},
  cities: {
    default: "Unknown",
    zurich: "Zurich",
    geneva: "Geneva",
    basel: "Basel",
    lausanne: "Lausanne",
    bern: "Bern",
    winterthur: "Winterthur",
    lucerne: "Lucerne",
    st_gallen: "St. Gallen",
    lugano: "Lugano",
    biel_bienne: "Biel/Bienne",
    thun: "Thun",
    koniz: "Köniz",
    la_chaux_de_fonds: "La Chaux-de-Fonds",
    fribourg: "Fribourg",
    schaffhausen: "Schaffhausen",
  },
  taxCantons: {
    default: "Unknown",
    aargau: "Aargau",
    appenzell_ausserrhoden: "Appenzell Ausserrhoden",
    appenzell_innerrhoden: "Appenzell Innerrhoden",
    basel_landschaft: "Basel-Landschaft",
    basel_stadt: "Basel-Stadt",
    bern: "Bern",
    fribourg: "Fribourg",
    geneva: "Geneva",
    glarus: "Glarus",
    graubunden: "Graubünden",
    jura: "Jura",
    lucerne: "Lucerne",
    neuchatel: "Neuchâtel",
    nidwalden: "Nidwalden",
    obwalden: "Obwalden",
    schaffhausen: "Schaffhausen",
    schwyz: "Schwyz",
    solothurn: "Solothurn",
    st_gallen: "St. Gallen",
    thurgau: "Thurgau",
    ticino: "Ticino",
    uri: "Uri",
    valais: "Valais (Wallis)",
    vaud: "Vaud",
    zug: "Zug",
    zurich: "Zurich",
  },
  languages: {
    fr: 'French',
    de: 'German',
    en: 'English',
    rm: 'Romanisch'
  },
  employeesMaritalStatus: {
    default: "Unknown",
    single: "Single",
    married: "Married",
    divorced: 'Divorced',
    widowed: 'Widowed',
    separated: 'Separated',
    registered_partnership: 'Registered partnership',
    partnership_resolved_by_right: 'Parnership resolved by right',
    partnership_dissolved_due_to_death: 'Partnership dissolved due to death',
    partnership_dissolved_due_to_declaration_of_absence: 'Partnership dissolved due to declaration of absence',
    unknown: 'Unknown'
  },
  employeesSalaryType: {
    hourly: 'Hourly',
    monthly: 'Monthly',
    default: 'Unknown'
  },
  employeesWorkingPermit: {
    'L - short time': 'L - short time',
    'A - short time': 'A - short time',
    'B - annual': 'B - annual',
    'C - of establishment': 'C - of establishment',
    'G - border': 'G - border',
    'N - asylum seeker': 'N - asylum seeker',
    'S - people of protect': 'S - people of protect',
    'Swisse': 'Swisse',
    'Others': 'Others',
    default: 'Unknown'
  },
  workingHoursComments: {
    vacancy: 'Vacation',
    leave: 'Leave',
    'public-holidays': 'Public holiday',
    diseases: 'Illness',
    accidents: 'Accident',
    default: 'Unknown'
  },
  booleanYesNo: {
    default: "No",
    yes: "Yes",
    no: "No",
  },
  booleanNumber: {
    default: "No",
    1: "Yes",
    0: "No",
  },
  boolean: {
    false: 'No',
    true: 'Yes'
  }
}

const commonTableFilters = {
  filter: "Filters",
  search: "Search filters",
  filterTypes: {
    dateRange: {
      label: "Date range",
      helperText: "Value represents server date",
      invalidRange: ": invalid range",
      maxDate: ": max date exceeded",
      minDate: ": min date exceeded",
    },
    selectStaticMultiple: {
      placeholder: "Select",
      noOptionsText: "No available options",
      select: "Select",
    },
    selectStaticSingle: {
      placeholder: "Select",
      noOptionsText: "No available options",
    },
    countrySelect: {
      placeholder: "Select country",
    },
    selectAjaxMultiple: {
      text: "No available options",
      placeholder: "Search",
      loading: "Loading",
    },
  },
  sortAsc: "Sort column ascending",
  sortDesc: "Sort column descending",
  hideColumn: "Hide column",
  clearStickyColumn: "Clear sticky column",
  setStickyColumn: "Set sticky column",
  clearStickyRow: "Clear sticky row",
  setStickyRow: "Set sticky row",
  noData: "No data",
  pinColumnLeft: "Pin column left",
  pinColumnRight: "Pin column right",
  unpinColumn: "Unpin column",
};

const commonModalTranslations = {
  required: 'Required',
  affectedRows: 'Affected rows',
  itemSelectedForBulk: "Item selected for bulk",
  create: "Create",
  noItemsSelectedForAddConstant: "No items selected for add constant",
  add: "Add",
  row: "row",
  month: "month",
  footer: {
    reset: "Reset",
    cancel: "Cancel",
    submit: "Submit",
    serverMessage: 'Server message'
  },
  body: {
    warning: "This action can not be undone!",
    question: "Are you sure you want to delete ",
    noItems: "No items selected for bulk delete",
    isLoading: "Deleting",
    isSuccess: "Successfully deleted",
    isError: "Error during delete",
    itemSelected: "Item selected for bulk delete",
  },
  filepond: {
    labelIdle: "Drag & Drop your files or <span class='filepond--label-action'> Browse </span>",
    labelInvalidField: "Field contains invalid files",
    labelFileProcessing: "Uploading",
    labelFileRemoveError: "Error during remove'",
    labelFileLoadError: "Error during load",
    labelTapToCancel: "tap to cancel",
    labelFileProcessingComplete: "Upload complete",
    labelFileProcessingAborted: "Upload cancelled",
    labelButtonProcessItem: "Upload",
    labelButtonRetryItemProcessing: "Retry",
    labelButtonAbortItemProcessing: "Cancel",
    labelButtonUndoItemProcessing: "Undo",
    labelTapToUndo: 'tap to undo',
    labelFileLoading: 'Loading'
  }
};

const commonTableTranslations = {
  header: {
    filters: "Filters",
    sortAsc: "Sort ascending",
    sortDesc: "Sort descending",
    all: "All",
    refreshData: "Refresh data",
    columnsEditor: "Columns editor",
    visualLayers: "Visual layers",
    emptySpace: "Fill table empty space",
    bulkOptions: "Bulk options",
    orderColumns: "Select or reorder table columns",
    enable: "Enable auto fill on screen resize",
    disable: "Disable auto fill on screen resize",
  },
  body: {
    pinRow: "Pin Row",
  },
};

const modalFieldsErrors = {
  required: 'Required',
  minimum: `minimum {minChar} characters`,
  maximum: `maximum {maxChar} characters`,
  min: `min allowed {min}`,
  max: 'max allowed {max}',
  email: 'wrong format',
  domain: 'wrong format (http/https)://domain.com)',
  fieldsDontMatch: "field doesn't match {matchFieldLabel}"
}

const EN = {
  modalFieldsErrors,
  MenuSegment: {
    admin: 'Admin',
    user: 'User',
    system: 'System',
    dev: 'Dev'
  },
  Navbar: {
    profile: 'Profile',
    logout: 'Logout'
  },
  Footer: {
    confirm: 'Confirm',
    logout: 'Logout'
  },
  MenuLink: {
    [moduleNames.ADMIN_HOME]: 'Home',
    [moduleNames.ADMIN_USERS]: 'Users',
    [moduleNames.ADMIN_EMPLOYEES]: 'Employees',
    [moduleNames.ADMIN_EMPLOYEES_ABSENCE]: 'Employees absence',
    [moduleNames.ADMIN_EMPLOYEES_NOTES]: 'Employees notes',
    [moduleNames.ADMIN_LOGIN_HISTORY]: 'Login history',
    [moduleNames.ADMIN_COMPANIES]: 'Companies',
    [moduleNames.ADMIN_FORMS_DROPDOWN]: 'Forms',
    [moduleNames.ADMIN_FORMS_TEMPLATES]: 'Templates',
    [moduleNames.ADMIN_FORMS_SUBMISSIONS]: 'Submissions',
    [moduleNames.ADMIN_WORKING_SITES]: 'Working sites',
    [moduleNames.ADMIN_WORKING_SITES_PLANNER]: 'Planner',
    [moduleNames.ADMIN_WORKING_HOURS_DROPDOWN]: 'Working hours',
    [moduleNames.ADMIN_WORKING_HOURS]: 'Annual',
    [moduleNames.ADMIN_WORKING_HOURS_SUBMISSIONS]: 'Submissions',
    [moduleNames.ADMIN_TAX_SCALES]: 'Tax scales',
    [moduleNames.ADMIN_TAX_SCALES_DETAILS]: 'Tax scales details',
    [moduleNames.ADMIN_TAX_EMPLOYEES]: 'Tax Employees',
    [moduleNames.ADMIN_CANTONS]: 'Cantons',
    [moduleNames.ADMIN_COMMUNE]: 'Communes',
    [moduleNames.ADMIN_CANTONS_HOLIDAYS]: 'Canton holidays',
    [moduleNames.ADMIN_CITIES]: 'Cities',
    [moduleNames.ADMIN_PROFILE]: 'Profile',
    [moduleNames.ADMIN_GROUPS]: 'Groups',
    [moduleNames.ADMIN_REPORT]: 'Report',
    [moduleNames.ADMIN_REPORT_EMPLOYEES]: 'Employees',
    [moduleNames.ADMIN_REPORT_WORKING_SITES]: 'Working sites',
    [moduleNames.ADMIN_REPORT_WORK_TABLE]: 'Work table',
    [moduleNames.ADMIN_SPREADSHEETS]: 'Spreadsheets',


    [`${moduleNames.DEV_BUILDER_DROPDOWN}_admin`]: 'Builder',
    [`${moduleNames.DEV_BUILDER_MODULE}_admin`]: 'Module',
  },
  PermissionsModalBody: {
    admin: 'Admin',
    [EPM.ADMIN_USERS]: 'Users',
    [EP.ADMIN_USERS_LIST]: 'List',
    [EP.ADMIN_USERS_CREATE]: 'Create',
    [EP.ADMIN_USERS_UPDATE]: 'Update',
    [EP.ADMIN_USERS_DELETE]: 'Delete',

    [EPM.ADMIN_COMPANIES]: 'Companies',
    [EP.ADMIN_COMPANIES_LIST]: 'List',
    [EP.ADMIN_COMPANIES_CREATE]: 'Create',
    [EP.ADMIN_COMPANIES_UPDATE]: 'Update',
    [EP.ADMIN_COMPANIES_DELETE]: 'Delete',

    [EPM.ADMIN_EMPLOYEES]: 'Employees',
    [EP.ADMIN_EMPLOYEES_LIST]: 'List',
    [EP.ADMIN_EMPLOYEES_CREATE]: 'Create',
    [EP.ADMIN_EMPLOYEES_UPDATE]: 'Update',
    [EP.ADMIN_EMPLOYEES_DELETE]: 'Delete',
    [EP.ADMIN_EMPLOYEES_FILES]: 'Files',
    [EP.ADMIN_EMPLOYEES_IMAGE]: 'Image',

    [EPM.ADMIN_EMPLOYEES_NOTES]: 'Employees notes',
    [EP.ADMIN_EMPLOYEES_NOTES_LIST]: 'List',
    [EP.ADMIN_EMPLOYEES_NOTES_CREATE]: 'Create',
    [EP.ADMIN_EMPLOYEES_NOTES_UPDATE]: 'Update',
    [EP.ADMIN_EMPLOYEES_NOTES_DELETE]: 'Delete',

    [EPM.ADMIN_EMPLOYEES_ABSENCE]: 'Employees absence',
    [EP.ADMIN_EMPLOYEES_ABSENCE_LIST]: 'List',
    [EP.ADMIN_EMPLOYEES_ABSENCE_CREATE]: 'Create',
    [EP.ADMIN_EMPLOYEES_ABSENCE_UPDATE]: 'Update',
    [EP.ADMIN_EMPLOYEES_ABSENCE_DELETE]: 'Delete',

    [EPM.ADMIN_SPREADSHEETS]: 'Spreadsheets',
    [EP.ADMIN_SPREADSHEETS_LIST]: 'List',
    [EP.ADMIN_SPREADSHEETS_CREATE]: 'Create',
    [EP.ADMIN_SPREADSHEETS_DELETE]: 'Delete',

    [EPM.ADMIN_REPORT]: 'Report',
    [EP.ADMIN_REPORT_EMPLOYEES]: 'Employees',
    [EP.ADMIN_REPORT_WORKING_SITES]: 'Working sites',
    [EP.ADMIN_REPORT_WORK_TABLE]: 'Work table',

    [EPM.ADMIN_TAX_SCALES]: 'Tax scales',
    [EP.ADMIN_TAX_SCALES_LIST]: 'List',
    [EP.ADMIN_TAX_SCALES_CREATE]: 'Create',
    [EP.ADMIN_TAX_SCALES_UPDATE]: 'Update',
    [EP.ADMIN_TAX_SCALES_DUPLICATE]: 'Duplicate',

    [EPM.ADMIN_TAX_SCALES_DETAILS]: 'Tax scales details',
    [EP.ADMIN_TAX_SCALES_DETAILS_LIST]: 'List',
    [EP.ADMIN_TAX_SCALES_DETAILS_CREATE]: 'Create',
    [EP.ADMIN_TAX_SCALES_DETAILS_UPDATE]: 'Update',
    [EP.ADMIN_TAX_SCALES_DETAILS_DELETE]: 'Delete',

    [EPM.ADMIN_TAX_EMPLOYEES]: 'Tax employees',
    [EP.ADMIN_TAX_EMPLOYEES_LIST]: 'List',
    [EP.ADMIN_TAX_EMPLOYEES_CREATE]: 'Create',
    [EP.ADMIN_TAX_EMPLOYEES_GET]: 'Get',

    [EPM.ADMIN_CANTONS]: 'Cantons',
    [EP.ADMIN_CANTONS_LIST]: 'List',
    [EP.ADMIN_CANTONS_CREATE]: 'Create',
    [EP.ADMIN_CANTONS_UPDATE]: 'Update',
    [EP.ADMIN_CANTONS_DELETE]: 'Delete',

    [EPM.ADMIN_CANTONS_HOLIDAYS]: 'Canton holidays',
    [EP.ADMIN_CANTONS_HOLIDAYS_LIST]: 'List',
    [EP.ADMIN_CANTONS_HOLIDAYS_CREATE]: 'Create',
    /* [EP.ADMIN_CANTONS_HOLIDAYS_UPDATE]: 'Update', */
    [EP.ADMIN_CANTONS_HOLIDAYS_DELETE]: 'Delete',

    [EPM.ADMIN_COMMUNE]: 'Communes',
    [EP.ADMIN_COMMUNE_LIST]: 'List',
    [EP.ADMIN_COMMUNE_CREATE]: 'Create',
    [EP.ADMIN_COMMUNE_UPDATE]: 'Update',
    [EP.ADMIN_COMMUNE_DELETE]: 'Delete',

    [EPM.ADMIN_CITIES]: 'Cities',
    [EP.ADMIN_CITIES_LIST]: 'List',
    [EP.ADMIN_CITIES_CREATE]: 'Create',
    [EP.ADMIN_CITIES_UPDATE]: 'Update',
    [EP.ADMIN_CITIES_DELETE]: 'Delete',

    [EPM.ADMIN_PERMISSIONS]: 'Permission',
    [EP.ADMIN_PERMISSIONS_GET]: 'Get',
    [EP.ADMIN_PERMISSIONS_UPDATE]: 'Update',

    [EPM.ADMIN_FORMS_TEMPLATES]: 'Forms templates',
    [EP.ADMIN_FORMS_TEMPLATES_LIST]: 'List',
    [EP.ADMIN_FORMS_TEMPLATES_CREATE]: 'Create',
    [EP.ADMIN_FORMS_TEMPLATES_UPDATE]: 'Update',
    [EP.ADMIN_FORMS_TEMPLATES_DELETE]: 'Delete',
    [EP.ADMIN_FORMS_TEMPLATES_GET_LINK]: 'Get link',

    [EPM.ADMIN_FORMS_SUBMISSIONS]: 'Forms submissions',
    [EP.ADMIN_FORMS_SUBMISSIONS_LIST]: 'List',
    [EP.ADMIN_FORMS_SUBMISSIONS_GET]: 'Get',

    [EPM.ADMIN_WORKING_SITES]: 'Working sites',
    [EP.ADMIN_WORKING_SITES_LIST]: 'List',
    [EP.ADMIN_WORKING_SITES_CREATE]: 'Create',
    [EP.ADMIN_WORKING_SITES_UPDATE]: 'Update',
    [EP.ADMIN_WORKING_SITES_DELETE]: 'Delete',

    [EPM.ADMIN_WORKING_SITES_PLANNER]: 'Planner',
    [EP.ADMIN_WORKING_SITES_PLANNER_LIST]: 'List',
    [EP.ADMIN_WORKING_SITES_PLANNER_CREATE]: 'Create',
    [EP.ADMIN_WORKING_SITES_PLANNER_CREATE_CONSTANT]: 'Create constant',
    [EP.ADMIN_WORKING_SITES_PLANNER_GET]: 'Get',
    [EP.ADMIN_WORKING_SITES_PLANNER_UPDATE]: 'Update',
    [EP.ADMIN_WORKING_SITES_PLANNER_DELETE]: 'Delete',

    [EPM.ADMIN_EMPLOYEES_PLANNER]: 'Employee planner filter',
    [EP.ADMIN_EMPLOYEES_PLANNER_LIST]: 'List',

    [EPM.ADMIN_WORKING_HOURS]: 'Working hours annual',
    [EP.ADMIN_WORKING_HOURS_LIST]: 'List',
    [EP.ADMIN_WORKING_HOURS_GET]: 'Get',
    [EP.ADMIN_WORKING_HOURS_UPDATE]: 'Update',
    [EP.ADMIN_WORKING_HOURS_CREATE]: 'Create',
    [EP.ADMIN_WORKING_HOURS_TOTALS]: 'Totals',

    [EPM.ADMIN_WORKING_HOURS_SUBMISSIONS]: 'Working hours submissions',
    [EP.ADMIN_WORKING_HOURS_SUBMISSIONS_LIST]: 'List',
    [EP.ADMIN_WORKING_HOURS_SUBMISSIONS_GET]: 'Get',
    [EP.ADMIN_WORKING_HOURS_SUBMISSIONS_UPDATE]: 'Update',

    [EPM.ADMIN_GROUPS]: 'Groups',
    [EP.ADMIN_GROUPS_LIST]: 'List',
    [EP.ADMIN_GROUPS_CREATE]: 'Create',
    [EP.ADMIN_GROUPS_UPDATE]: 'Update',
    [EP.ADMIN_GROUPS_DELETE]: 'Delete',

    common: 'Common',
    [EPM.SETTINGS]: 'Settings',
    [EP.SETTINGS_GET]: 'Get',
    [EP.SETTINGS_UPDATE]: 'Update',

  },
  DashboardFooter: {
    companyName: 'CRM', /* SHOULD_CHANGE */
    craftedLeft: 'Crafted with',
    craftedRight: 'by Damir&Nadir' /* SHOULD_CHANGE */
  },
  Logout: {
    title: 'Logout',
    loading: 'Waiting to safely log out',
    completed: 'You have been safely logged out',
    button: 'Back to Login'
  },
  RequestErrors: {
    default: 'Unknown error',
    browser: {
      ERR_NETWORK: 'Network error'
    },
    network: {
      401: 'Unauthenticated user',
      403: 'Insufficient permissions',
      405: 'Method not allowed',
      406: 'Request not acceptable'
    },
    internal: {
      0: "Unknown error.",
      1: "Requested method is not allowed.",
      2: "Login data not provided.",
      3: "Username is not in the correct format.",
      4: "Password is not in the correct format.",
      5: "Login data is incorrect.",
      6: "Database error.",
      7: "POST request is not in the correct format.",
      8: "Input is not valid.",
      9: "Entry already exists in the database.",
      10: "ID must be passed as a query parameter.",
      11: "Requested ID not found in the database.",
      12: "One of the search parameters (e.g., ID) must be provided.",
      13: "Query parameter is not in the correct format.",
      14: "Requested user not found in the database.",
      15: "Requested country not found in the database.",
      16: "User does not have permission for the requested module/action.",
      17: "MySQL table name must be provided.",
      18: "Value not found in the selected table.",
      19: "Error in passing key/value parameters.",
      20: "File format is not allowed.",
      21: "Record in the database is deleted and cannot be edited.",
      22: "Exceeded the limit of active sessions for your IP address.",
      23: "Form is already filled.",
      24: "Email not found in the database.",
      25: "Form is already filled for a certain period.",
      26: "It is not allowed to edit a date older than 7 days.",
      27: "Start time cannot be the same or earlier than end time.",
      28: "Entered time is out of working hours for that day.",
      29: "Total working hours exceed the allowed working hours for that day.",
      30: "Times overlap, entry is not possible.",
      31: "It is not allowed to define a group more than once within a year.",
      32: "Min salary is greater than or equal to max salary.",
      33: "File not found on the server / upload error.",
      34: "Entry is already approved for that date.",
      35: "Unable to find tax scale.",
      36: "Start date must be less than end date.",
      37: "Entry is not possible, the employee is not scheduled to work that day.",
      38: "Group combination of worksite and employee already exists.",
      39: "The employee has already entered working hours in the system, it is not possible to delete them",
      40: "It is necessary to correctly enter working hours for each site",
      41: "The selected combination of site and employee already exists in one of the entered groups",
      42: "The request has been approved",
      43: "The request has been canceled",
      44: "The employee already has recorded working hours for this site and date",
      45: "Start date must be greater than last working date",
      46: "End date must be less than fist day back",
      47: "There is an entry for that date, no more changes are allowed",
      48: "It is only possible to change dates from the future ( tomorrow + )",
      49: "It is not possible to enter working hours in the future."
    },
    custom: {}
  },

  [moduleNames.ADMIN_LOGIN_HISTORY]: {
    browserTabTitle: 'CRM - Admin | Login history',/* SHOULD_CHANGE */
  },
  // Add this to the existing EN object in the file

  [moduleNames.ADMIN_COMPANIES]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | Companies',
    createLabel: 'Add',
    editLabel: 'Edit',
    editBulkLabel: 'Edit',
    createModalTitle: 'Create company',
    editModalTitle: 'Edit company',
    editModalBulkTitle: 'Edit companies',
    deleteBulkLabel: 'Delete companies',
    deleteLabel: 'Delete company',
    deleteModalTitle: 'Delete company',
    deleteModalBulkTitle: 'Delete companies',
    viewCompanyLabel: 'View company',
    filters: {
      name: { label: 'Name' },
      note: { label: 'Note' },
      canton_id: { label: 'Canton', description: 'Search by name' },
      commune_id: { label: 'Commune', description: 'Search by name' }
    },
    columns: {
      'id': 'ID',
      'name': 'Name',
      'note': 'Note',
      'canton.name': 'Canton',
      'commune.name': 'Commune',
      'updated_at': 'Updated',
      'created_at': 'Created'
    },
    formData: {
      name: { label: 'Name' },
      canton_id: { label: 'Canton' },
      commune_id: { label: 'Commune' },
      note: { label: 'Note' }
    }
  },

  [moduleNames.ADMIN_SPREADSHEETS]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | Spreadsheets',
    createLabel: 'Add',
    deleteLabel: 'Delete',
    createModalTitle: 'Create',
    deleteModalTitle: 'Delete',
    filters: {
      type: { label: 'Type', },
    },
    columns: {
      'id': 'ID',
      'type': 'Type',
      'url': 'Download',
      'status': 'Status',
      'created_at': 'Created',
      "name": "Name",
    },
    formData: {
      type: { label: 'Type' },
      name: { label: 'Name' },
      year: { label: 'Year' },
      trimester: { label: 'Trimester' },
      employees: { label: 'Employees' },
      company_name: { label: 'Company name' },
      company_address: { label: 'Company address' },
      company_zip: { label: 'Company zip' },
      company_person_in_charge: { label: 'Person in charge' },
    }
  },

  [moduleNames.ADMIN_USERS]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | Users',/* SHOULD_CHANGE */
    createLabel: 'Add',
    editLabel: 'Edit',
    authLabel: 'Auth',
    permissionsLabel: 'Permissions',
    deleteLabel: 'Delete',
    editBulkLabel: 'Edit',
    deleteBulkLabel: 'Delete',
    createModalTitle: 'Create user',
    editModalTitle: 'Edit user',
    authModalTitle: 'Edit user password',
    permissionModalTitle: 'User permissions',
    deleteModalTitle: 'Delete user',
    deleteModalBulkTitle: 'Delete users',
    editModalBulkTitle: 'Edit users',
    filters: {
      username: { label: 'Username', description: 'Search by username', },
      email: { label: 'Email', description: 'Enter full email' },
      first_name: { label: 'First name' },
      last_name: { label: 'Last name' },
      status: { label: 'Status' }
    },
    columns: {
      'info.id': 'ID',
      'data.username': 'Username',
      'data.email': 'Email',
      'data.status': 'Status',
      'data.first_name': 'First name',
      'data.last_name': 'Last name',
      'edited.timestamp': 'Edited',
      'created.timestamp': 'Created',
    },
    formData: {
      firstName: { label: 'First name' },
      lastName: { label: 'Last name' },
      email: { label: 'Email' },
      status: { label: 'Status' },
      password: { label: 'Password' },
      repeatPassword: { label: 'Repeat Password' },
    }
  },

  [moduleNames.ADMIN_EMPLOYEES_ABSENCE]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | Employees absence',/* SHOULD_CHANGE */
    createLabel: 'Add',
    editLabel: 'Edit',
    editBulkLabel: 'Edit',
    createModalTitle: 'Create absence',
    editModalTitle: 'Edit absence',
    editModalBulkTitle: 'Edit absences',
    deleteBulkLabel: 'Delete absences',
    deleteModalTitle: 'Delete absence',
    deleteLabel: 'Delete',
    deleteModalTitle: 'Delete absence',
    deleteModalBulkTitle: 'Delete absences',
    filters: {
      employee_id: { label: 'Employee' },
      start_date: { label: 'Start date', },
      end_date: { label: 'End date' },
      type: { label: 'Type' },
      year: { label: 'Year' },
      month: { label: 'Month' },
    },
    columns: {
      'info.id': 'ID',
      'data.last_day_of_work': 'Last day of work',
      'data.first_day_back': 'First day of work',
      'data.start_date': 'Start date',
      'data.end_date': 'End date',
      'data.employee.number': 'Employee number',
      'data.employee.first_name': 'First name',
      'data.employee.last_name': 'Last name',
      'data.type': 'Type',
      'created.timestamp': 'Created'
    },
    formData: {
      startDate: { label: 'Start date' },
      endDate: { label: 'Last date' },
      firstDayOfWork: { label: 'First day of work' },
      lastDayOfWork: { label: 'Last day of work' },
      type: { label: 'Type' },
      employee_id: { label: 'Employee' },
    },
  },

  [moduleNames.ADMIN_EMPLOYEES_NOTES]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | Employees note',/* SHOULD_CHANGE */
    createLabel: 'Add',
    editLabel: 'Edit',
    editBulkLabel: 'Edit',
    createModalTitle: 'Create note',
    editModalTitle: 'Edit note',
    editModalBulkTitle: 'Edit notes',
    deleteBulkLabel: 'Delete notes',
    deleteModalTitle: 'Delete note',
    deleteLabel: 'Delete',
    deleteModalTitle: 'Delete note',
    deleteModalBulkTitle: 'Delete notes',
    filters: {
      employee_id: { label: 'Employee' },
      created_user_id: { label: 'Created by', description: "Search by username" },
    },
    columns: {
      'info.id': 'ID',
      'info.employee.first_name': 'First name',
      'info.employee.last_name': 'Last name',
      'info.created_user_username': 'Created by',
      'data.note': 'Note',
      'created.timestamp': 'Created'
    },
    formData: {
      employee_id: { label: 'Employee' },
      note: { label: 'Note' },
    },
  },

  [moduleNames.ADMIN_EMPLOYEES_SINGLE]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | Employee',
    editLabel: 'Edit',
    child: 'Child',
    noChildren: 'No children added',
    tabsGeneral: {
      employee: 'Employee',
      spouse: 'Spouse',
      children: 'Children',
    },
    tabs: {
      general: 'General',
      workingHours: 'Working hours'
    },
    sections: {
      personal: 'Personal',
      addressPrimar: 'Address primar',
      addressSecundar: 'Address secundar',
      businessInfo: 'Professional',
      salary: 'Salary',
      files: 'Files'
    },
    workingHours: {
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
      allowed_working_hours: 'Allowed working hours',
      start_time: 'Start time',
      end_time: 'End time',
      day: 'Day',
      noDataText: 'No working hours entered for this employee'
    },
    columns: {
      "info.id": "ID",
      "data.personal.employee_number": "Employee number",
      "data.personal.first_name": "First name",
      "data.personal.last_name": "Last name",
      "data.personal.sex": "Sex",
      "data.personal.status": "Status",
      "data.personal.email": "Email",
      "data.personal.phone": "Phone",
      "data.personal.date_of_birth": "Date of birth",
      "data.personal.avs_number": "No.AVS",
      "data.personal.religion": "Religion",
      "data.personal.nationality": "Nationality",
      "data.personal.has_children": "Has children",
      "data.personal.number_of_children": "Number of children",
      "data.personal.marital_status": "Marital status",
      "data.personal.date_of_marriage": "Date of marriage",
      "data.address_primar.address": "Address",
      "data.address_primar.city_extended.name": "City",
      "data.address_primar.commune_extended.name": "Commune",
      "data.address_primar.canton_extended.name": "Canton",
      "data.address_primar.country_extended.name": "Country",
      "data.address_primar.contact_phone": "Contact phone",
      "data.address_secundar.address": "Address",
      "data.address_secundar.city_extended.name": "City",
      "data.address_secundar.commune_extended.name": "Commune",
      "data.address_secundar.canton_extended.name": "Canton",
      "data.address_secundar.country_extended.name": "Country",
      "data.address_secundar.contact_phone": "Contact phone",
      "data.business_info.job_type": "Job type",
      "data.business_info.job_title": "Job title",
      "data.business_info.key_number": "Key number",
      "data.business_info.weekly_hours": "Weekly hours",
      "data.business_info.other_employer": "Other employer",
      "data.business_info.other_employer_rate": "Other employer rate",
      "data.business_info.other_employer_start_date": "Other employer start date",
      "data.business_info.working_permit": "Working permit",
      "data.business_info.working_permit_expiration_date": "Working permit expiration date",
      "data.business_info.employment_date": "Employment date",
      "data.business_info.resignation_date": "Resignation date",
      "data.business_info.working_site_extended.name": "Working site",
      "data.salary.rate": "Rate",
      "data.salary.type": "Type",
      "data.salary.bank_account_number": "Bank account number",
      "data.salary.tax_canton_extended.name": "Tax canton",
      "data.salary.tax_country_extended.name": "Tax country",
      "data.files.avs_card": "Avs card",
      "data.files.bank_details": "Bank details",
      "data.files.identity_card": "Identity card",
      "data.files.criminal_record": "Criminal record",
      "data.files.contract": "Contract",
      "data.files.external_prosecution_office": "External prosecution office",
      'data.spouse_personal.first_name': "First name",
      'data.spouse_personal.last_name': "Last name",
      'data.spouse_personal.sex': "Sex",
      'data.spouse_personal.date_of_birth': "Date of birth",
      'data.spouse_personal.avs_number': "No.AVS",
      'data.spouse_personal.religion': "Religion",
      'data.spouse_personal.has_children': "Has children",
      'data.spouse_personal.number_of_children': "Number of children",
      'data.spouse_personal.marital_status': "Marital status",
      'data.spouse_personal.date_of_marriage': "Date of marriage",
      'data.spouse_address_primar.address': "Address",
      'data.spouse_address_primar.city_extended.name': "City",
      'data.spouse_address_primar.commune_extended.name': "Commune",
      'data.spouse_address_primar.canton_extended.name': "Canton",
      'data.spouse_address_primar.country_extended.name': "Country",
      'data.spouse_address_primar.contact_phone': "Contact phone",
      'data.spouse_business_info.other_employer': "Other employer",
      'data.spouse_business_info.other_employer_rate': "Other employer rate",
      'data.spouse_business_info.other_employer_start_date': "Other employer start date",
      'data.spouse_business_info.working_permit': "Working permit",
      'data.spouse_files.avs_card': "Avs card",
      'data.spouse_files.identity_card': "Identity card",
      'personal.first_name': "First name",
      'personal.last_name': "Last name",
      'personal.sex': "Sex",
      'personal.date_of_birth': "Date of birth",
      'personal.nationality': "Nationality",
      "address_primar.address": "Address",
      "address_primar.city_extended.name": "City",
      "address_primar.commune_extended.name": "Commune",
      "address_primar.canton_extended.name": "Canton",
      "address_primar.country_extended.name": "Country",
      "address_primar.contact_phone": "Contact phone",
    },
  },

  [moduleNames.ADMIN_EMPLOYEES]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | Employees',/* SHOULD_CHANGE */
    createLabel: 'Add',
    editLabel: 'Edit',
    editBulkLabel: 'Edit',
    createModalTitle: 'Create employee',
    editModalTitle: 'Edit employee',
    editModalBulkTitle: 'Edit employees',
    deleteModalTitle: 'Delete employee',
    deleteLabel: 'Delete',
    viewEmployeeLabel: 'View employee',
    personal: 'Personal',
    business_info: 'Business info',
    files: 'Files',
    child: 'Child',
    addressPrimar: 'Primary address',
    addressSecundar: 'Secondary address',
    address: 'Address',
    getLink: 'Get link for user registration',
    linkModalTitle: 'Get link for user registration',
    successText: 'Thank you! 🥳 We will review your submission shortly.',
    filters: {
      email: { label: 'Email', description: 'Enter full email', },
      first_name: { label: 'First name', },
      last_name: { label: 'Last name' },
      status: { label: 'Status' },
      employeeNumber: { label: 'Employee number' },
      sex: { label: 'Gender' },
      avs_number: { label: 'No.AVS' },
      has_children: { label: 'Has children' },
      marital_status: { label: 'Marital status' },
      company_id: { label: 'Company' },
    },
    columns: {
      'info.id': 'ID',
      'data.personal.status': 'Status',
      'data.personal.employee_number': 'Employee number',
      'data.personal.first_name': 'First name',
      'data.personal.last_name': 'Last name',
      'data.business_info.company_extended.name': 'Company',
      'data.personal.email': 'Email',
      'data.personal.no_avs': 'No.AVS',
      'data.personal.phone_number': 'Phone',
      'data.personal.sex': 'Gender',
      'data.personal.has_children': 'Has children',
      'data.personal.marital_status': 'Marital status',
      'edited.timestamp': 'Edited',
      'created.timestamp': 'Created'
    },
    formData: {
      status: { label: 'Status' },
      employee_number: { label: 'Employee number' },
      notes: { label: 'Notes' },
      personalFirstName: { label: 'First name' },
      personalLastName: { label: 'Last name' },
      personalEmail: { label: 'Email' },
      personalNationality: { label: 'Nationality' },
      personalNoAvs: { label: 'No.AVS' },
      personalDob: { label: 'Date of birth' },
      personalMaritalStatus: { label: 'Marital status' },
      personalReligion: { label: 'Religion' },
      personalHasChildren: { label: 'Has children' },
      personalNumberOfChildren: { label: 'Number of children' },
      personalDateOfMarriage: { label: 'Date of marriage' },
      personalSex: { label: 'Sex' },
      personalPhone: { label: 'Phone number' },

      allowedWorkingHours: { label: 'Allowed working hours' },

      addressPrimarAddress: { label: 'Address' },
      addressSecundarAddress: { label: 'Address' },
      addressPrimarCity: { label: 'City' },
      addressSecundarCity: { label: 'City' },
      addressPrimarCountry: { label: 'Country' },
      addressSecundarCountry: { label: 'Country' },
      addressPrimarCanton: { label: 'Canton' },
      addressSecundarCanton: { label: 'Canton' },
      addressPrimarCommune: { label: 'Commune' },
      addressSecundarCommune: { label: 'Commune' },
      addressPrimarContactPhone: { label: 'Contact phone (if needed)' },
      addressSecundarContactPhone: { label: 'Contact phone (if needed)' },
      addressPrimarContactPhoneChild: { label: 'Contact phone (if needed)' },

      businessInfoShowWorkingHours: { label: 'Show working hours' },
      businessInfoSiteId: { label: 'Working site' },
      businessInfoEmploymentDate: { label: 'Employment date' },
      businessInfoResignationDate: { label: 'Resignation date' },
      businessInfoJobTitle: { label: 'Job title' },
      businessInfoJobType: { label: 'Job type' },
      businessInfoKeyNumber: { label: 'Key number' },
      businessInfoWeeklyHours: { label: 'Weekly hours' },
      businessInfoWorkingPermit: { label: 'Working permit' },
      businessInfoOtherEmployer: { label: 'Other employer' },
      businessInfoOtherEmployerStartDate: { label: 'Other employer start date' },
      businessInfoWorkingPermitExpirationDate: { label: "Working permit expiration" },

      salaryBankAccountNumber: { label: 'Bank account number' },
      salaryType: { label: 'Salary type' },
      salaryRate: { label: 'Rate' },
      salaryTaxCanton: { label: 'Tax canton' },
      salaryTaxCountry: { label: 'Tax country' },

      monday: { label: 'Monday' },
      tuesday: { label: 'Tuesday' },
      wednesday: { label: 'Wednesday' },
      thursday: { label: 'Thursday' },
      friday: { label: 'Friday' },
      saturday: { label: 'Saturday' },
      sunday: { label: 'Sunday' },
      freeDay: { label: 'Free day' },
      startTime: { label: 'Start time' },
      endTime: { label: 'End time' },
      totalAllowedHours: { label: 'Total allowed hours' },

      fileAvsCard: { label: 'Avs card' },
      fileBankDetails: { label: 'Bank details' },
      fileIdentityCard: { label: 'Identity card' },
      fileCriminalRecord: { label: 'Criminal record' },
      fileExternalProsecutionOffice: { label: 'Prosecution office' },
      fileContract: { label: 'Contract' },

      spousePersonalFirstName: { label: 'First name' },
      spousePersonalLastName: { label: 'Last name' },
      spousePersonalNoAvs: { label: 'No.AVS' },
      spousePersonalDob: { label: 'Date of birth' },
      spousePersonalMaritalStatus: { label: 'Marital status' },
      spousePersonalReligion: { label: 'Religion' },
      spousePersonalHasChildren: { label: 'Has children' },
      spousePersonalNumberOfChildren: { label: 'Number of children' },
      spousePersonalDateOfMarriage: { label: 'Date of marriage' },
      spousePersonalSex: { label: 'Sex' },

      spouseAddressPrimarAddress: { label: 'Address' },
      spouseAddressPrimarCity: { label: 'City' },
      spouseAddressPrimarCountry: { label: 'Country' },
      spouseAddressPrimarCanton: { label: 'Canton' },
      spouseAddressPrimarCommune: { label: 'Commune' },
      spouseAddressPrimarContactPhone: { label: 'Contact phone' },

      spouseBusinessInfoWorkingPermit: { label: 'Working permit' },
      spouseBusinessInfoOtherEmployer: { label: 'Other employer' },
      spouseBusinessInfoOtherEmployerRate: { label: 'Other employer rate' },
      spouseBusinessInfoOtherEmployerStartDate: { label: 'Other employer start date' },

      spouseFileAvsCard: { label: 'Avs card' },
      spouseFileIdentityCard: { label: 'Identity card' },

      children: { label: 'Children' },
      primar: { label: 'Primary' },
      secundar: { label: 'Secondary' }
    },
    tabs: {
      personal: 'Personal',
      address: 'Address',
      shipping: 'Shipping',
      professional: 'Professional',
      salary: 'Salary',
      files: 'Files',
      required: 'Required',
      workingHours: 'Working hours',
      spouse: 'Spouse',
      children: 'Children',
      bussinesInfo: 'Business info'
    }
  },

  [moduleNames.ADMIN_COMMUNE]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | Communes',/* SHOULD_CHANGE */
    createLabel: 'Add',
    editLabel: 'Edit',
    editBulkLabel: 'Edit',
    createModalTitle: 'Create commune',
    editModalTitle: 'Edit commune',
    editModalBulkTitle: 'Edit communes',
    deleteBulkLabel: 'Delete communes',
    deleteLabel: 'Delete commune',
    deleteModalTitle: 'Delete commune',
    deleteModalBulkTitle: 'Delete communes',
    viewCommuneLabel: 'View commune',
    filters: {
      name: { label: 'Name' },
      canton_id: { label: 'Canton', },
      language: { label: 'Language' }
    },
    columns: {
      'info.id': 'ID',
      'info.name': 'Name',
      'info.canton.name': 'Canton',
      'info.canton.postal_code': 'Postal code',
      'info.canton.code': 'Canton code',
      'info.language': 'Language',
      'edited.timestamp': 'Edited',
      'created.timestamp': 'Created'
    },
    formData: {
      name: { label: 'Name' },
      canton_id: { label: 'Canton' },
      language: { label: 'Language' },
    },
  },

  [moduleNames.ADMIN_TAX_SCALES]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | Tax scales',/* SHOULD_CHANGE */
    createLabel: 'Add',
    editLabel: 'Edit',
    editBulkLabel: 'Edit',
    createModalTitle: 'Create tax scale',
    editModalTitle: 'Edit tax scale',
    editModalBulkTitle: 'Edit tax scales',
    deleteBulkLabel: 'Delete tax scales',
    deleteLabel: 'Delete tax scale',
    deleteModalTitle: 'Delete tax scale',
    deleteModalBulkTitle: 'Delete tax scales',
    duplicateLabel: 'Duplicate',
    duplicateModalTitle: 'Duplicate',
    duplicateModalBody: 'Are you sure you want to duplicate this record?',
    detailsLabel: 'Details',
    absences: {
      vacancy: 'V',
      leave: 'C',
      'public-holidays': 'F',
      diseases: 'M',
      accidents: 'A',
      default: 'D'
    },
    filters: {
      name: { label: 'Name' },
      group: { label: 'Group' },
      year: { label: 'Year' }
    },
    columns: {
      'info.id': 'ID',
      'info.name': 'Name',
      'info.group': 'Group',
      'info.year': 'Year',
      'edited.timestamp': 'Edited',
      'created.timestamp': 'Created'
    },
    formData: {
      name: { label: 'Name' },
      group: { label: 'Group' },
      year: { label: 'Year' },
    },
  },

  [moduleNames.ADMIN_TAX_SCALES_DETAILS]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | Tax scales details',/* SHOULD_CHANGE */
    createLabel: 'Add',
    editLabel: 'Edit',
    editBulkLabel: 'Edit',
    createModalTitle: 'Create',
    editModalTitle: 'Edit tax scale',
    editModalBulkTitle: 'Edit tax scales',
    deleteBulkLabel: 'Delete tax scales',
    deleteLabel: 'Delete tax scale',
    deleteModalTitle: 'Delete tax scale',
    deleteModalBulkTitle: 'Delete tax scales',
    addNewRow: 'Add new row',
    detailsFor: 'Details for',
    useDecimalNotice: 'Please use , instead of . for decimal separators',
    columns: {
      'info.id': 'ID',
      'data.min_salary': 'Min salary',
      'data.max_salary': 'Max salary',
      'data.children.0': 'Childless',
      'data.children.1': 'Child 1',
      'data.children.2': 'Child 2',
      'data.children.3': 'Child 3',
      'data.children.4': 'Child 4',
      'data.children.5': 'Child 5',
      'data.children.6': 'Child 6',
      'data.children.7': 'Child 7',
      'data.children.8': 'Child 8',
    },
    formData: {
      min_salary: { label: 'Min salary*' },
      max_salary: { label: 'Max salary*' },
      0: { label: 'Child 1' },
      1: { label: 'Child 2' },
      2: { label: 'Child 3' },
      3: { label: 'Child 4' },
      4: { label: 'Child 5' },
      5: { label: 'Child 6' },
      6: { label: 'Child 7' },
      7: { label: 'Child 8' },
      child0: { label: 'Child 1' },
      child1: { label: 'Child 2' },
      child2: { label: 'Child 3' },
      child3: { label: 'Child 4' },
      child4: { label: 'Child 5' },
      child5: { label: 'Child 6' },
      child6: { label: 'Child 7' },
      child7: { label: 'Child 8' },
    },
    filters: {
      min_salary: { label: 'Min salary' },
      max_salary: { label: 'Max salary' },
    },
  },

  [moduleNames.ADMIN_TAX_EMPLOYEES]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | Tax employees',/* SHOULD_CHANGE */
    createLabel: 'Add',
    editLabel: 'Edit',
    editBulkLabel: 'Edit',
    createModalTitle: 'Create',
    editModalTitle: 'Edit',
    editModalBulkTitle: 'Edit',
    deleteBulkLabel: 'Delete',
    deleteLabel: 'Delete',
    getLabel: 'Get',
    deleteModalTitle: 'Delete',
    additionalInfoModal: {
      firstName: 'First name',
      lastName: 'Last name',
      employeeNumber: 'Employee number',
      taxScale: 'Tax scale',
      numberOfChildren: 'Children'
    },
    filters: {
      year: { label: 'Year' },
      trimester: { label: 'Trimester' },
      status: { label: 'Status' },
      employee_number: { label: 'Employee number' },
      employee_id: { label: 'Employee', description: 'Search by first name' }
    },
    columns: {
      'id': 'ID',
      'year': 'Year',
      'trimester': 'Trimester',
      'status': 'Status',
      'created_at': 'Created at',
      'created_by': 'Created by',
      'file_url': 'File',
    },
    formData: {
      year: { label: 'Year' },
      trimester: { label: 'Trimester' },
      employees: { label: 'Employees' },
      order_number: { label: 'Order number' },
      company_name: { label: 'Company name' },
      company_address: { label: 'Company address' },
      company_zip: { label: 'Company zip' },
      company_person_in_charge: { label: 'Company person in charge' },
    },
  },

  [moduleNames.ADMIN_WORKING_HOURS]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | Working hours annual',/* SHOULD_CHANGE */
    createLabel: 'Add',
    createModalTitle: 'Add working hours record',
    editLabel: 'Edit',
    editModalTitle: 'Edit',
    editBulkLabel: 'Edit',
    totalsLabel: 'Totals',
    addNewRow: 'Add new row',
    start_time: "Start time",
    end_time: "End time",
    filters: {
      employee_id: { label: 'Employee' },
      year: { label: 'Year' },
    },
    formData: {
      supposed_working_hours: { label: 'Supposed working hours' },
      date: { label: 'Date' },
      note: { label: 'Note' }
    },
    columns: {
      "day": "Day",
      "months.january": "January",
      "months.february": "February",
      "months.march": "March",
      "months.april": "April",
      "months.may": "May",
      "months.june": "June",
      "months.july": "July",
      "months.august": "August",
      "months.september": "September",
      "months.october": "October",
      "months.november": "November",
      "months.december": "December",
    },
    absences: {
      vacancy: 'V',
      leave: 'C',
      'public-holidays': 'F',
      diseases: 'M',
      accidents: 'A',
      default: 'D'
    }
  },

  [moduleNames.ADMIN_WORKING_HOURS_TOTALS]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | Working hours totals',/* SHOULD_CHANGE */
    createLabel: 'Add',
    editLabel: 'Edit',
    editModalTitle: 'Edit',
    editBulkLabel: 'Edit',
    totalsLabel: 'Totals',
    detailsFor: 'Total for',
    formData: {
      supposed_working_hours: { label: 'Supposed working hours' }
    },
    columns: {
      "month": "Month",
      "total_working_hours": "Working hours",
      "total_supposed_working_hours": "Supposed working hours",
      "total_hours_difference": "Difference",
      "total_earned": "Earned",
      "total_holidays": "Holidays",
      "total_vacations": "Vacations",
      "remaining_vacations": "Remaining vacations",
      "totals": 'Totals',
    },
    absences: {
      vacancy: 'V',
      leave: 'C',
      'public-holidays': 'F',
      diseases: 'M',
      accidents: 'A',
      default: 'D'
    }
  },

  [moduleNames.ADMIN_CANTONS]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | Cantons',/* SHOULD_CHANGE */
    createLabel: 'Add',
    editLabel: 'Edit',
    editBulkLabel: 'Edit',
    createModalTitle: 'Create canton',
    editModalTitle: 'Edit canton',
    editModalBulkTitle: 'Edit cantons',
    deleteBulkLabel: 'Delete cantons',
    deleteModalTitle: 'Delete city',
    deleteLabel: 'Delete canton',
    deleteModalTitle: 'Delete canton',
    deleteModalBulkTitle: 'Delete cantons',
    filters: {
      name: { label: 'Name' },
      postal_code: { label: 'Postal code', },
      code: { label: 'Canton code' },
      country_id: { label: 'Country' }
    },
    columns: {
      'info.id': 'ID',
      'info.name': 'Name',
      'info.country_id': 'Country',
      'info.postal_code': 'Postal code',
      'info.code': 'Canton code',
      'edited.timestamp': 'Edited',
      'created.timestamp': 'Created'
    },
    formData: {
      name: { label: 'Name' },
      postal_code: { label: 'Postal code' },
      country_id: { label: 'Country' },
      code: { label: 'Canton code' },
    },
  },

  [moduleNames.ADMIN_CITIES]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | Cities',/* SHOULD_CHANGE */
    createLabel: 'Add',
    editLabel: 'Edit',
    editBulkLabel: 'Edit',
    createModalTitle: 'Create city',
    editModalTitle: 'Edit city',
    editModalBulkTitle: 'Edit cities',
    deleteBulkLabel: 'Delete cities',
    deleteLabel: 'Delete',
    deleteModalTitle: 'Delete city',
    filters: {
      name: { label: 'Name' },
      canton_id: { label: 'Canton' },
      commune_id: { label: 'Commune' }
    },
    columns: {
      'info.id': 'ID',
      'info.name': 'Name',
      'info.canton_name': 'Canton',
      'edited.timestamp': 'Edited',
      'created.timestamp': 'Created'
    },
    formData: {
      name: { label: 'Name' },
      canton_id: { label: 'Canton' },
      communes: { label: 'Communes' },
    },
  },

  [moduleNames.ADMIN_CANTONS_HOLIDAYS]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | Canton holidays',/* SHOULD_CHANGE */
    createLabel: 'Add',
    editLabel: 'Edit',
    editBulkLabel: 'Edit',
    createModalTitle: 'Create holiday',
    editModalTitle: 'Edit holiday',
    editModalBulkTitle: 'Edit holidays',
    deleteLabel: 'Delete',
    deleteBulkLabel: 'Delete holidays',
    deleteModalTitle: 'Delete holiday',
    deleteModalBulkTitle: 'Delete holidays',
    filters: {
      name: { label: 'Name' },
      date_range: { label: 'Date range' },
      canton_id: { label: 'Canton' }
    },
    columns: {
      'info.id': 'ID',
      'info.name': 'Name',
      'info.start_date': 'Start date',
      'info.end_date': 'End date',
      'info.cantons.name': 'Canton',
      'edited.timestamp': 'Edited',
      'created.timestamp': 'Created'
    },
    formData: {
      name: { label: 'Name' },
      canton_id: { label: 'Canton' },
      start_date: { label: 'Start date' },
      end_date: { label: 'End date' },
    },
  },

  [moduleNames.ADMIN_WORKING_SITES]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | Working sites',/* SHOULD_CHANGE */
    createLabel: 'Add',
    editLabel: 'Edit',
    deleteLabel: 'Delete',
    editBulkLabel: 'Edit',
    deleteBulkLabel: 'Delete',
    createModalTitle: 'Add working site',
    editModalTitle: 'Edit working site',
    deleteModalTitle: 'Delete working site',
    deleteModalBulkTitle: 'Delete working sites',
    editModalBulkTitle: 'Edit working sites',
    filters: {
      city: {
        label: 'City',
      },
      phone: { label: 'Phone' },
      name: { label: 'Name' },
      status: { label: 'Status' },
    },
    columns: {
      'info.id': 'ID',
      'data.name': 'Name',
      'info.city.name': 'City',
      'data.phone': 'Phone',
      'data.address': 'Address',
      'data.contact_person': 'Contact person',
      'edited.timestamp': 'Edited',
      'created.timestamp': 'Created',
      'data.status': 'Status'
    },
    formData: {
      name: { label: 'Name' },
      city: { label: 'City' },
      address: { label: 'Address' },
      contact_person: { label: 'Contact person' },
      phone: { label: 'Phone' },
      status: { label: 'Status' },
    }
  },

  [moduleNames.ADMIN_WORKING_HOURS_SUBMISSIONS]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | Working hours submissions',/* SHOULD_CHANGE */
    additionalInfoLabel: 'Additional info',
    editLabel: 'Edit',
    editModalTitle: 'Edit working hours',
    filters: {
      date: {
        label: 'Date',
      },
      year: {
        label: 'Year'
      },
      month: {
        label: 'Month'
      },
      employee_id: {
        label: 'Employee',
        description: 'Search by first name'
      },
      start_time: {
        label: 'Start time',
      },
      end_time: {
        label: 'End time',
      },
      working_time: {
        label: 'Working time',
      },
    },
    columns: {
      'id': 'ID',
      'employee_number': 'Employee number',
      'first_name': 'First name',
      'last_name': 'Last name',
      'date': 'Date',
      'start_time': 'Start time',
      'end_time': 'End time',
      'working_time': 'Working time',
      'comments': 'Comment',
      'notes': 'Note',
      'status': 'Status',
    },
    formData: {
      status: { label: 'Status' }
    },
    additionalInfoModal: {
      totalWorkingHours: 'Total working hours',
      workingSite: 'Working site',
      startTime: 'Start time',
      endTime: 'End time',
      workingTime: 'Working time'
    }
  },

  [moduleNames.ADMIN_FORMS_TEMPLATES]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | Forms templates',/* SHOULD_CHANGE */
    createLabel: 'Add',
    editLabel: 'Edit',
    deleteLabel: 'Delete',
    editBulkLabel: 'Edit',
    getLinkLabel: 'Get link',
    getLinkModalLabel: 'Get link',
    deleteBulkLabel: 'Delete',
    createModalTitle: 'Add template',
    editModalTitle: 'Edit template',
    deleteModalTitle: 'Delete template',
    deleteModalBulkTitle: 'Delete templates',
    filters: {
      name: {
        label: 'Name',
      },
      description: {
        label: 'Description',
      },
      status: {
        label: 'Status '
      },
    },
    columns: {
      'info.id': 'ID',
      'data.name': 'Name',
      'data.description': 'Description',
      'info.status': 'Status',
      'data.expires': 'Expires',
      'data.target': 'Target',
      'edited.timestamp': 'Edited',
      'created.timestamp': 'Created',
    },
    formData: {
      name: { label: 'Name' },
      description: { label: 'Description' },
      fields: { label: 'Fields' },
      target: { label: 'Target' },
      expires: { label: 'Expires' },
      addQuestionText: 'Add a question',
      fields: {
        'input': 'Text input',
        'select-single': 'Dropdown',
        'select-multiple': 'Dropdown multiple select',
        'date': 'Date',
        'time-range': 'Time range',
        'time': 'Time',
        'radio': 'Single select',
        'checkbox': 'Checkbox (multiple select)',
        'question': 'Question',
        'required': 'Required',
        'addAnOption': 'Add an option',
        'options': 'Options',
        'selectList': 'Select list'
      }
    }
  },

  [moduleNames.ADMIN_FORMS_SUBMISSIONS]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | Forms submissions',/* SHOULD_CHANGE */
    viewLabel: 'View',
    viewTitle: 'View answers',
    filters: {
      email: {
        label: 'Email',
        description: "Enter full email"
      },
      target: {
        label: 'Target',
      },
    },
    columns: {
      'info.id': 'ID',
      'data.email': 'Email',
      'data.first_name': 'First name',
      'data.last_name': 'Last name',
      'data.target': 'Target',
      'created.timestamp': 'Created',
    }
  },

  [moduleNames.ADMIN_PROFILE]: {
    modalFieldsErrors,
    browserTabTitle: 'CRM - Profile', /* SHOULD_CHANGE */
    profileGeneralSettings: 'Profile general settings',
    profileAuthSettings: 'Profile auth settings',
    general: 'General',
    changePassword: 'Change password',
    password: 'Password',
    repeatPassword: 'Password',
    saveChanges: 'Save changes',
    firstName: 'First name',
    lastName: 'Last name',
    successfullyUpdated: 'Successfully updated!'
  },

  [moduleNames.ADMIN_WORKING_SITES_PLANNER]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    editModalTitle: 'Edit',
    working_hours: 'Working hours',
    addNewRow: 'Add new row',
    total: 'Total',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    createModalTitle: "Create constant",
    createLabel: "Create",
    createModalInfo: "Create a constant planner. Ex: if you select date: 07/07/2024 (Sunday), recurrence type: weekly, interval: 1, duration: this year - The submission would apply for every Sunday in this year, starting from 07/07/2024",
    groupAdd: "Add group",
    individualAdd: "Add individually",
    name: 'Name',
    workingSite: 'Site',
    time: 'Time',
    infoModalTitle: 'Info for',
    deleteLabel: "Delete",
    deleteModalTitle: "Delete",
    deleteModalInfo: "Delete planner entries. Ex: if you select date: 07/07/2024 (Sunday), recurrence type: weekly, interval: 1, duration: this year - The submission would apply for every Sunday in this year, starting from 07/07/2024",
    totalHoursWorked: "Total hours worked",
    totalHoursToWork: "Total hours to work",
    filters: {
      employee_id: { label: 'Employee' },
      date: { label: 'Date' },
      working_site_id: { label: 'Working site' },
      group_id: { label: 'Group' },
      employeeNumber: { label: 'Employee number' },
      company_id: { label: 'Company' },
    },
    formData: {
      site_data: { label: 'Site data' },
      date: { label: "Start date" },
      recurrence_type: { label: "Recurrence type" },
      interval: { label: "Interval" },
      duration: { label: "Duration" },
      dayOfWeek: { label: "Day of week" },
      weekOfMonth: { label: "Week of month" }
    }

  },

  [moduleNames.ADMIN_GROUPS]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | Groups',
    createLabel: 'Add',
    editLabel: 'Edit',
    authLabel: 'Auth',
    deleteLabel: 'Delete',
    editBulkLabel: 'Edit',
    deleteBulkLabel: 'Delete',
    createModalTitle: 'Create group',
    editModalTitle: 'Edit group',
    deleteModalTitle: 'Delete group',
    deleteModalBulkTitle: 'Delete groups',
    filters: {
      employee: { label: 'Employee' },
      working_site: { label: 'Working site' },
      label: { label: "Label" }
    },
    columns: {
      'info.id': 'ID',
      'data.label': 'Label',
      'data.employees': 'Employees',
      'data.employees_count': 'Employees #',
      'data.working_sites': 'Working sites',
      'data.working_sites_count': 'Working sites #',
      'edited.timestamp': 'Edited',
      'created.timestamp': 'Created',
    },
    formData: {
      label: { label: 'Label' },
      emloyees: { label: 'Employees' },
      working_sites: { label: 'Working sites' },
    }
  },

  [moduleNames.ADMIN_REPORT_EMPLOYEES]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | report employees',
    filters: {
      employee: { label: 'Employee' },
      month: { label: 'Month' },
      year: { label: 'Year' },
    },
    columns: {
      'day': 'Day',
      'site_name': 'Site',
    }
  },

  [moduleNames.ADMIN_REPORT_WORKING_SITES]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | report working sites',
    hoursWorked: 'Hours worked',
    plannedHours: 'Planned hours to work',
    filters: {
      working_site: { label: 'Working site' },
      month: { label: 'Month' },
      year: { label: 'Year' },
    },
    columns: {
      'date': 'Date',
      'site_name': 'Site',
    }
  },

  [moduleNames.ADMIN_REPORT_WORK_TABLE]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | report work table',
    filters: {
      month: { label: 'Month' },
      year: { label: 'Year' },
      employee: { label: 'Employee' },
    },
    columns: {
      'employee_name': 'Employee',
    }
  },

  workingHoursWeb: {
    modalFieldsErrors,
    enumTranslations,
    workingHoursFor: 'Working hours for',
    selectDate: 'Select date',
    workingSite: 'Working site',
    startTime: 'Start time',
    endTime: 'End time',
    remove: 'Remove',
    totalHoursWorked: 'Total hours worked',
    note: 'Note',
    comment: 'Comment',
    reset: 'Reset',
    save: 'Save',
    addAnotherRow: 'Add another row',
    logOut: 'Log out',
    pleaseEnterEmployeeNumber: 'Please enter your employee number',
    enterEmployeeNumber: 'Enter employee number',
    submit: 'Submit',
    fillOutFields: 'Please fill out all of the fields',
    successfullyUpdated: 'Successfully updated!'
  },

  webPlanner: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    working_hours: 'Working hours',
    addNewRow: 'Add new row',
    total: 'Total',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    filters: {
      date: { label: 'Date' },
    },
  }
}

export default EN;